import {
  Box,
  mdBumps,
  ModalHeader,
  PrimaryButton,
  SingleSelect,
  Typo,
} from '@wrisk/ui-components'
import React, { FC, useCallback, useMemo, useState } from 'react'

import {
  tDefaults,
  tEntries,
  TKeyBuilder,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { RenewalConfig } from '../../../state/configuration'
import { WriskTrans } from '../trans'

export interface AutoRenewalModalProps {
  tKey: TKeyBuilder
  initialValue: boolean
  options: RenewalConfig['autoRenewalOptions']
  onChange: (isEnabled: boolean) => void
  isLoading: boolean
}

const toBoolean = (value: string) => value === 'true'

export const AutoRenewalModal: FC<AutoRenewalModalProps> = ({
  tKey,
  initialValue,
  options,
  onChange,
  isLoading,
}) => {
  const { t } = useWriskTranslation()

  const [autoRenewalEnabledValue, setAutoRenewalEnabledValue] = useState(
    String(initialValue),
  )

  const selectOptions = useMemo(
    () =>
      options
        ? Object.entries(options).reduce(
            (acc, [id, key]) => ({
              ...acc,
              [id]: t(tEntries('autoRenewal', key)),
            }),
            {},
          )
        : {},
    [options, t],
  )

  const onConfirm = useCallback(
    () => onChange(toBoolean(autoRenewalEnabledValue)),
    [autoRenewalEnabledValue, onChange],
  )

  return (
    <Box>
      <ModalHeader header={t(tKey('modal', 'header'))} />
      <Typo mb={mdBumps}>
        <WriskTrans t={t} i18nKey={tKey('modal', 'subheader')} />
      </Typo>
      <SingleSelect
        width={1}
        mb={mdBumps}
        name='autoRenewalEnabled'
        onChange={setAutoRenewalEnabledValue}
        value={autoRenewalEnabledValue}
        options={selectOptions}
      />
      <PrimaryButton layout='fixed' onClick={onConfirm} loading={isLoading}>
        {t([tKey('actions.confirm'), tDefaults('actions.confirm')])}
      </PrimaryButton>
    </Box>
  )
}
